import React, {useRef} from "react"
import JoditEditor from "jodit-react"
import PropTypes from "prop-types"

const config = {
    readonly: false,
    defaultActionOnPaste: "insert_as_html",
    disablePlugins: [
        "print",
        "video",
        "about",
        "poweredByJodit",
        "preview",
        "image",
        "speechRecognize",
        "spellcheck",
        "paste",
        "file",
        "class-span",
    ],
}

const WysiwygEditorWidget = ({widget, value, onValueChange}) => {
    const editor = useRef(null)   

    return (
        <JoditEditor
            ref={editor}
            value={value}
            config={config}
            tabIndex={1}
            onBlur={onValueChange}
        />
    )
}

WysiwygEditorWidget.propTypes = {
    widget: PropTypes.object,
    value: PropTypes.string,
    onValueChange: PropTypes.func,
}

export default WysiwygEditorWidget
